import { render, staticRenderFns } from "./redemption-grid.vue?vue&type=template&id=4afc2dca&"
import script from "./redemption-grid.vue?vue&type=script&lang=js&"
export * from "./redemption-grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports